import React, { useRef, useEffect } from "react";
import {
    Avatar,
    AvatarSvg,
    CategoryTitle,
    Info,
    Name,
    ResultGroup,
    ResultItem,
    ResultsList,
    SearchContainer,
} from "./ExtensionSearch";
import { toAbsoluteUrl } from "_metronic/_helpers";
import styled from "styled-components";
import { colors } from "app/popleads/components/ui-kit/colors";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import FeatherIcon from "feather-icons-react";

const StyledResultsList = styled(ResultsList)`
    position: absolute;
    top: 0;
    width: 300px;
    // left: 12px;
`;
const StyledCategoryTitle = styled(CategoryTitle)`
    font-size: 14px;
    color: ${colors.neutral[700]};
    font-weight: 500;
`;
const StyledResultItem = styled(ResultItem)`
    cursor: pointer;
    padding: 4px;
    width: 240px;
    margin-bottom: 0px;
`;

const Highlighted = styled.span`
    letter-spacing: -0.17px;
    color: #0085be;
    font-weight: 500;
`;

const TruncatedName = styled(Name)`
    min-width: initial;
    line-height: normal;
    width: min-content !important;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    min-width: 0;
    margin-right: 8px;
    width: 170px;
`;

const StyledInfo = styled(Info)`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0px;
    align-items: baseline;
`;

const InfoLine = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    line-height: 1.4;
    min-height: 1.4em;
    max-height: 1.4em;
    min-width: 0;
    margin-right: 4px;
`;

const CategoryIcon = styled(SVG)`
    flex-shrink: 0;
    width: 18px;
    height: 15px;
`;

const ResultWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 4px;
`;

const OpenProfileIcon = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    width: 32px;
    height: 32px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

const ExtensionFullSizeDropdown = ({
    handleResultClick,
    setIsOpen,
    isOpen,
    options,
    searchText,
    title,
    footerComponent,
}) => {
    const dropdownRef = useRef(null);

    const highlightText = (text, search) => {
        if (!search) return text;
        const regex = new RegExp(`(${search})`, "gi");
        const parts = text?.split(regex);

        return parts?.map((part, index) => (regex.test(part) ? <Highlighted key={index}>{part}</Highlighted> : part));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setIsOpen]);

    return (
        <SearchContainer ref={dropdownRef}>
            <StyledResultsList isOpen={isOpen}>
                <ResultGroup>
                    <StyledCategoryTitle>{title}</StyledCategoryTitle>
                    {options.map((result, index) => (
                        <ResultWrapper key={index}>
                            <StyledResultItem onClick={() => handleResultClick(result)}>
                                {result.resim ? (
                                    <Avatar src={result.resim} alt={result.ad} />
                                ) : (
                                    <AvatarSvg src={toAbsoluteUrl("/media/svg/icons/Extension/user-avatar.svg")} />
                                )}
                                <TextContainer>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip
                                                id={`tooltip-name-${index}`}
                                            >{`${result.ad} ${result.soyad}`}</Tooltip>
                                        }
                                    >
                                        <TruncatedName>
                                            {highlightText(`${result.ad} ${result.soyad}`, searchText)}
                                        </TruncatedName>
                                    </OverlayTrigger>
                                    <StyledInfo>
                                        {result.sirket && (
                                            <>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id={`tooltip-sirket-${index}`}>
                                                            {result.sirket}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <InfoLine style={{ fontWeight: 600, color: colors.neutral[700] }}>
                                                        {result.sirket}
                                                    </InfoLine>
                                                </OverlayTrigger>
                                            </>
                                        )}
                                        {result.baslik && (
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip id={`tooltip-baslik-${index}`}>{result.baslik}</Tooltip>
                                                }
                                            >
                                                <InfoLine>{result.baslik}</InfoLine>
                                            </OverlayTrigger>
                                        )}
                                    </StyledInfo>
                                </TextContainer>
                                {result.kategori && (
                                    <CategoryIcon
                                        src={toAbsoluteUrl("/media/svg/icons/Extension/pop-it.svg")}
                                        style={{
                                            fill:
                                                result.kategori === "lead" ? colors.success[900] : colors.warning[900],
                                        }}
                                    />
                                )}
                            </StyledResultItem>
                            {result.id && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id={`tooltip-open-${index}`}>Open profile in new tab</Tooltip>}
                                >
                                    <OpenProfileIcon
                                        onClick={() => {
                                            window.open(`/extension?profileId=${result.id}`, "_blank");
                                        }}
                                    >
                                        <FeatherIcon icon="external-link" size={16} color={colors.neutral[600]} />
                                    </OpenProfileIcon>
                                </OverlayTrigger>
                            )}
                        </ResultWrapper>
                    ))}
                    {footerComponent}
                </ResultGroup>
            </StyledResultsList>
        </SearchContainer>
    );
};

export default ExtensionFullSizeDropdown;
